import { Directive, ElementRef, EmbeddedViewRef, TemplateRef, ViewContainerRef, Input, OnInit } from '@angular/core';

import Swipe from 'swiper';

@Directive({
  selector: '[draInfiniteSwipe]'
})
export class DraInfiniteSwipeDirective implements OnInit {
  private options: {
    swiper: Swipe,
    currentIndex: number,
    total: number,
    getItem: Function,
    onChange: Function,
  };
  private parentElement;
  private swiper: Swipe;
  private viewElements: Map<number, EmbeddedViewRef<any>> = new Map();

  public constructor(
    private element: ElementRef,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {
    this.parentElement = this.element.nativeElement.parentElement.parentElement;
  }

  public ngOnInit(): void {
    this.swiper = new Swipe(this.parentElement, {
      setWrapperSize: true,
      spaceBetween: 30,
      initialSlide: 0,
      onSlidePrevStart: (swiper) => {
        if (this.options.currentIndex <= 0) return;
        this.options.currentIndex = this.options.currentIndex - 1;
      },
      onSlideNextStart: (swiper) => {
        if (!this.swiper) return;
        this.options.currentIndex = this.options.currentIndex + 1;
      },
      onSlideChangeEnd: (swiper) => {
        this.onChange();
      },
    });
  }

  public goTo(index): void {
    this.options.currentIndex = index;

    this.render(true);
  }
  public prev(): void {
    if (this.options.currentIndex > 0) {
      this.swiper.slidePrev();
    }
  }
  public next(): void {
    if (this.options.currentIndex + 1 < this.options.total) {
      this.swiper.slideNext();
    }
  }
  public async reloadCurrent() {
    if (!this.swiper) return;
    let currentSlide = this.swiper.slides[this.swiper.activeIndex];
    if (!currentSlide) return;

    let context = currentSlide.view.context;
    try {
      context.item = await this.options.getItem(this.options.currentIndex, true);
    } catch (error) {
      console.log(error);
    }
  }

  private onChange(): void {
    this.render();
  }
  private render(force?: boolean): void {
    let options = this.options;

    if (!options) return;

    let currentIndex = options.currentIndex;

    if (force) this.clear();

    if (force || (this.swiper && this.swiper.realIndex == 0)) {
      if (currentIndex > 0) this.renderItem(currentIndex - 1, true);

      // Remove
      if (this.swiper && this.swiper.slides.length > 2) {
        let element = this.swiper.slides[this.swiper.slides.length - 1];
        element.view.destroy();
        element.remove();
      }
    }

    if (force) this.renderItem(currentIndex);

    if (force || (this.swiper && this.swiper.realIndex == this.swiper.slides.length - 1)) {
      if (currentIndex < options.total - 1) this.renderItem(currentIndex + 1);

      if (this.swiper && this.swiper.slides.length > 2) {
        let element = this.swiper.slides[0];
        element.view.destroy();
        element.remove();
      }
    }

    this.options.onChange(currentIndex);

    if (this.swiper) {
      this.swiper.update();
      this.swiper.slideTo(this.options.currentIndex > 0 ? 1 : 0, 0, false, true);

      this.swiper.slides.each(slideIndex => this.swiper.slides[slideIndex].scrollTop = 0);
    }
  }

  private async renderItem(index, prepend: boolean = false): Promise<any> {
    // console.log(`Render item #${index}`);
    const context = {item: {}};
    let view = this.viewContainer.createEmbeddedView(this.templateRef, context, prepend ? 0 : undefined);

    view.rootNodes[0].view = view;

    this.viewElements.set(index, view);

    try {
      context.item = await this.options.getItem(index);
    } catch (error) {
      console.log(error);
    }

    return view;
  }
  private clear(): void {
    if (!this.swiper || !this.swiper.slides) return;
    this.swiper.slides.each((index, element) => {
      element.view.destroy();
      element.remove();
    });
  }
  @Input()
  private set draInfiniteSwipe(options) {
    if (!options) return;
    this.options = options;
    this.render(true);
  }
}



// WEBPACK FOOTER //
// ./src/directives/dra-infinite-swipe.directive.ts